// extracted by mini-css-extract-plugin
export default {"inputBorder":"style-module__aQTUc"};